import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { getAllUser } from "./management";
import { API_DOWNLOAD_USER_ON_MOBILE } from "../../../config/api";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";

export const downloadOnMobileUsersList = createAsyncThunk(
  "user/downloadOnMobileUsersList",
  async ({ callback, failed }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_DOWNLOAD_USER_ON_MOBILE,
      });

      callback(data);

      return data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      return rejectWithValue(error.message);
    }
  }
);
